// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__ty227","list":"PatternAutocomplete_list__1UGM5"};